import { flex } from '@ebh/capsule/theme';

export default {
  mainContainer: flex('row'),
};
